'use client';

import { FormSubmitButton, Skeleton } from '@baseball-near-you/ui';
import { Form, LargeCheckboxInput } from '@baseball-near-you/ui';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import { useUpdateUserMutation } from '@bb/lib/mutations/useUpdateUserMutation';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';

export enum Position {
  Pitcher = 'Pitcher',
  Catcher = 'Catcher',
  FirstBase = '1B',
  SecondBase = '2B',
  ThirdBase = '3B',
  Shortstop = 'SS',
  LeftField = 'LF',
  CenterField = 'CF',
  RightField = 'RF',
  Utility = 'Utility',
}

export function PersonalUserPositionForm(props: {
  onSuccess?: () => Promise<void>;
  submitButtonLabel?: string;
}) {
  const { userProfile } = useUserProfile();
  const { updateUser } = useUpdateUserMutation();

  return userProfile ? (
    <Form
      onSubmit={async ({ positions }) => {
        console.log({ positions, userProfile });
        if (!userProfile?.id) {
          return;
        }
        await updateUser({
          id: userProfile.id,
          positions: positions ?? null,
        });
        await props.onSuccess?.();
      }}
      schema={z.object({
        positions: z.array(z.nativeEnum(Position)),
      })}
      initialValues={{
        positions: userProfile?.positions ?? [],
      }}
    >
      <PositionInputs />
      <FormSubmitButton
        className="mt-4"
        label={props.submitButtonLabel ?? 'Update'}
      />
    </Form>
  ) : (
    <Skeleton />
  );
}

function PositionInputs() {
  const { watch, setValue } = useFormContext();
  const positions: Position[] = watch('positions');
  return (
    <div className="mt-4 grid grid-cols-2 gap-4">
      {Object.values(Position).map((position) => (
        <LargeCheckboxInput
          key={position}
          label={position}
          onChange={(e) => {
            if (e.target.checked) {
              setValue('positions', [...positions, position]);
            } else {
              setValue(
                'positions',
                positions.filter((p) => p !== position)
              );
            }
          }}
          checked={positions.includes(position)}
        />
      ))}
    </div>
  );
}
